import { type ReactNode, useState } from 'react';
import FadeInContent from '@/components/Animation/FadeInContent';
import ContentBoundary from './ContentBoundary';

export default function FormContentBoundary({
  loading,
  children,
  flex = true,
}: {
  loading: boolean;
  children: ReactNode;
  flex?: boolean;
}) {
  const [initiallyLoading] = useState(loading);
  const [ready, setReady] = useState(!loading);
  if (!loading && !ready) setReady(true);

  return (
    <ContentBoundary data={ready ? true : null} loading={loading} flex={flex}>
      {() => (
        <FadeInContent flex={flex} animateOnMount={initiallyLoading}>
          {children}
        </FadeInContent>
      )}
    </ContentBoundary>
  );
}
